import { removeNamespace } from '@/utils/helpers'
import $http from '@/plugins/axios'

export const SELECTS_TYPES = {
  mutations: {
    SET_LOADING: 'selects/SET_LOADING',
    SET_STATES: 'selects/SET_STATES',
    SET_COUNTRIES: 'selects/SET_COUNTRIES'
  },
  actions: {
    fetchStates: 'selects/fetchStates',
    fetchCountries: 'selects/fetchCountries',
    resetCountries: 'selects/resetCountries',
    saveCountries: 'selects/saveCountries'
  }
}

const _types = removeNamespace('selects', SELECTS_TYPES)

const state = () => ({
  loading: false,
  states: [],
  countries: []
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_STATES] (state, states) {
    state.states = states
  },
  [_types.mutations.SET_COUNTRIES] (state, countries) {
    state.countries = countries
  }
}

const actions = {
  async [_types.actions.fetchStates] ({ commit, state }) {
    if (state.states.length) {
      return
    }
    return $http().get(`store/states`)
      .then((res) => {
        commit(_types.mutations.SET_STATES, res)
      })
  },
  async [_types.actions.fetchCountries] ({ commit, state }) {
    if (state.countries.length) {
      return
    }
    return $http().get(`store/countries`)
      .then((res) => {
        commit(_types.mutations.SET_COUNTRIES, res)
      })
  },
  async [_types.actions.resetCountries] ({ commit, state }) {
    return $http().get(`store/countries`)
      .then((res) => {
        commit(_types.mutations.SET_COUNTRIES, res)
      })
  },
  async [_types.actions.saveCountries] ({ commit, state }) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().patch(`store/countries`, state.countries)
      .then((res) => {})
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
